<template>
  <div class="quick-cart-holder" :class="{show: itemsCount > 0}">
    <div class="container">
      <div class="quick-cart">
        <a class="quick-cart-btn" :href="orderPath">
          <div class="counter">{{ itemsCount }}</div>
          <i class="icon-cart" /> <span>{{ $t('cart') }}</span> <strong>{{ totalAmount | currency }}</strong>
          <i class="icon-order-arrow-bottom" />
        </a>
        <div class="quick-cart-overview">
          <ItemsList />
          <Total />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import ItemsList from './components/ItemsList';
import Total from './components/Total';

export default {
  name: 'App',
  components: {
    ItemsList,
    Total,
  },
  computed: {
    ...mapGetters(['totalAmount', 'itemsCount', 'orderPath']),
  },

  mounted() {
    const self = this;
    self.$store.dispatch('getCartContent');

    $('.quick-cart-holder').on('refreshCart', () => {
      self.$store.dispatch('getCartContent');
    });
  },
};
</script>

<i18n>
{
  "cs": {
    "cart":  "Váš košík:"
  },
  "sk": {
    "cart":  "Váš košík:"
  },
  "en": {
    "cart":  "Your cart:"
  }
}
</i18n>
